import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Grid, IconButton, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import MessageBox from "../../components/common/CustomMessageBox";
import CustomDelete from '../../components/common/CustomDeleteAlert';
import CustomModal from "../../components/common/CustomModal";
import { ENQUIRY_COMPANY_USER_CONVERT_TO_USER, ENQUIRY_COMPANY_USER_LIST, ENQUIRY_LEAD_CONVERT_TO_USER_ONBOARDING, ENQUIRY_SUBSCRIPTION_EXPIRY_REMINDER, PAYMENT_LINK_GENERATE, } from "../../services/apiRoutes";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../../components/common/CustomLoader";
import { ClearRounded, } from "@mui/icons-material";
import CustomButton from "../../components/common/CustomButton";
import CustomTextField from "../../components/common/CustomTextField";
import CustomFilter from "../../components/common/CustomFilter";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { hasEditPermission, hasDeletePermission } from '../../services/CommonServices'
import { useLocation } from "react-router-dom";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../../components/common/CustomDataTable";
import CustomAutocomplete from "../../components/common/CustomAutoComplete";

const title = 'User Onboarding';

const EnquiryUserOnboarding = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null); // State to hold selected ID
    const [clientCompanies, setClientCompanies] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const [rowId, setRowId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [permission, setPermissions] = useState()
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [convertLoadingId, setConvertLoadingId] = useState(null);

    const [filterPayload, setFilterPayload] = useState({
        fromDate: '',
        toDate: '',
        companyName: '',
        mobile: '',
        setupStatus: '',
        email: ''
    });
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);

    const navigate = useNavigate();

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                fromDate: '',
                toDate: '',
                companyName: '',
                mobile: '',
                setupStatus: '',
                email: ''
            });
            subscriptionData(0, pageSize, '');
        };
    }, [pageSize]);

    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        setPermissions({
            edit: editPermision,
            delete: deletePermission
        })
    }, [])

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "userName", header: "User Name", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            { accessorKey: "mobile", header: "Contact No.", size: 100, enableSorting: true, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: "email", header: "Email ID", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "clientCompanyName", header: "Company", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "paymentLink",
                header: "Payment Link",
                size: 50,
                enableSorting: false,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>

                            <Button
                                variant="outlined"
                                onClick={() => handleSubmitPAYMENT_LINK_GENERATE(row.original.email)}
                                disabled={convertLoadingId === row.original.email}
                                sx={{
                                    color: '#007BFF',
                                    borderColor: '#007BFF',
                                    textTransform: "capitalize",
                                    height: "25px",
                                    padding: "2px 6px",
                                }}
                            >
                                {convertLoadingId === row.original.email ? (
                                    <CircularProgress size={18} sx={{ color: "#007BFF" }} />
                                ) : (
                                    "Send"
                                )}
                            </Button>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: "setupStatus",
                header: "Setup",
                size: 50,
                enableSorting: false,
                Cell: ({ row }) => {
                    const isCompleted = row.original.setupStatus;

                    return (

                        <>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => handleConvertLead(row.original.enquiryUserId)}
                                    disabled={convertLoadingId === row.original.enquiryUserId}
                                    sx={{
                                        color: isCompleted ? '#2e7d32' : '#ed6c02',
                                        borderColor: isCompleted ? '#2e7d32' : '#ed6c02',
                                        display: 'inline-flex',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        textTransform: "capitalize",
                                        height: "25px",
                                        padding: "2px 6px 2px 6px",
                                        width: 'fit-content',
                                        '&:hover': {
                                            borderColor: isCompleted ? '#2e7d32' : '#ed6c02',
                                            color: isCompleted ? '#2e7d32' : '#ed6c02',
                                            backgroundColor: 'transparent',
                                        },
                                        '&.Mui-disabled': {
                                            borderColor: isCompleted ? '#2e7d32' : '#ed6c02',
                                            color: isCompleted ? '#2e7d32' : '#ed6c02',
                                            opacity: 0.7,
                                        },


                                    }}
                                >
                                    {convertLoadingId === row.original.enquiryUserId ? (
                                        <CircularProgress size={18} sx={{ color: "#007BFF" }} />
                                    ) : isCompleted ? (
                                        "Complete"
                                    ) : (
                                        "In-Complete"
                                    )}

                                </Button>
                            </div>
                        </>
                    );
                },
            },

        ],
        [permission,]
    );

    const handleConvertLead = async (enquiryUserId) => {
        setConvertLoadingId(enquiryUserId);
        try {
            const accessToken = sessionStorage.getItem("accessToken");

            const response = await axios.post(
                ENQUIRY_COMPANY_USER_CONVERT_TO_USER(enquiryUserId), // ✅ leadId in URL
                {}, // ✅ no payload needed (unless backend expects it)
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setMessage({
                    open: true,
                    text: response.data?.message || "Lead converted to onboarding user successfully",
                    type: "success",
                });
                subscriptionData();
            }
        } catch (error) {
            console.error("Convert lead error:", error);
            setMessage({
                open: true,
                text: error.response?.data?.message || "Something went wrong",
                type: "error",
            });
        } finally {
            setConvertLoadingId(null);
        }
    };

    const subscriptionData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };
            const response = await genericPost(ENQUIRY_COMPANY_USER_LIST, payload, {});
            if (response?.data?.success && response?.data?.data) {
                const subscriptionData = response.data.data.map((item, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    id: item.enquiryUserId || "",
                    enquiryUserId: item.enquiryUserId || "",
                    userName: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
                    mobile: item.mobile || "",
                    email: item.email || "",
                    clientCompanyName: item.clientCompany?.companyName || "",
                    setupStatus: item.setupStatus,
                }));

                setClientCompanies(subscriptionData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError('No subscription records found');
            }
        } catch (error) {
            console.error('Error fetching subscriptions:', error);
            setError('Error fetching subscription data');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitPAYMENT_LINK_GENERATE = async (email) => {
        setConvertLoadingId(email);

        try {
            const payload = {
                email: email,   // ✅ only email in body
            };

            const response = await genericPost(PAYMENT_LINK_GENERATE, payload);

            if (response?.status === 200 || response?.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Payment link sent successfully",
                    type: "success",
                });
            }
            if (response?.status === 400) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Please complete the company setup before generating the payment link.",
                    type: "error",
                });
            }
        } catch (error) {
            setMessage({
                open: true,
                text: error?.response?.data?.message || "Failed to generate payment link",
                type: "error",
            });
        } finally {
            setConvertLoadingId(null);
        }
    };

    useEffect(() => {
        subscriptionData(page, pageSize,)
    }, [page, pageSize, token,])


    return (
        <>
            <Box sx={{ padding: '10px' }}>
                <CustomLoader open={loading} />
                <CustomDataTable
                    title={title}
                    columns={columns}
                    data={clientCompanies}
                    handleFilterButton={filterOpen}
                    fiterButtonTitile="Fiter"
                    rowCount={rowCount}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    fromDate={filterPayload.fromDate || ""}
                    toDate={filterPayload.toDate || ""}
                />
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomFilter
                    drawerTitle="Filter Options"
                    drawerWidth={300}
                    openDrawer={openDrawer}
                    onClose={filterClose}
                    drawerContent={
                        <>
                            <Box>
                                <Grid container spacing={1} sx={{ padding: 0, }}>
                                    <Grid item xs={8} sm={12} md={12}>
                                        <CustomAutocomplete
                                            options={setupStatusList}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Select Status"
                                            onChange={(event, newValue) => handleFilterChange("setupStatus", newValue?.id)}
                                            value={setupStatusList.find((item) => item.id === filterPayload.setupStatus) || null}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <CustomTextField
                                            placeholder="Mobile"
                                            type="number"
                                            value={filterPayload.mobile}
                                            onChange={(e) => handleFilterChange('mobile', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomTextField
                                            placeholder="Email"
                                            type="text"
                                            value={filterPayload.email}
                                            onChange={(e) => handleFilterChange('email', e.target.value)}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="from Date"
                                            type="date"
                                            value={filterPayload.fromDate}
                                            onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                            placeholder="From Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="to Date"
                                            type="date"
                                            value={filterPayload.toDate}
                                            onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                            placeholder="To Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>

                                        <CustomButton
                                            startIcon={<FindReplaceOutlinedIcon />}
                                            title="Apply"
                                            size="small"
                                            variant="contained"
                                            onClick={subscriptionData}
                                        />
                                        <CustomButton
                                            variant="outlined"
                                            title="Clear"
                                            startIcon={<ClearRounded />}
                                            style={cif_fob_style}
                                            onClick={handleClearFilters}
                                        />

                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    }
                />

            </Box>
        </>
    );
};

export default EnquiryUserOnboarding;

const cif_fob_style = {
    backgroundColor: '#ffff',
    color: '#007bff',
    textTransform: "capitalize",
    borderRadius: 4,
    border: '1px solid #007bff',
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100px"
}
const setupStatusList = [
    {
        id: '0',
        title: "Incomplete"
    },
    {
        id: '1',
        title: "Complete"
    }
];
